export default __webpack_public_path__ + "static/craig-280cabfdf89ac17aa7d4a0555f08b27b.png";